import apps from '../appsList';

function HomePage() {
  return (
    <>
      <section className="hero">
        <div className="hero-content reveal" style={{ '--delay': '0ms' }}>
          <span className="eyebrow">Two activity streams, one team</span>
          <h1>Lean Factor delivers project leadership and app products under distinct brands.</h1>
          <p className="lede">
            We support organizations with structured project management through Lean Factor,
            while JellyBeanStudios builds practical apps that make everyday work and life simpler.
          </p>
          <div className="hero-actions">
            <a className="btn primary" href="#/contact">
              Talk with us
            </a>
          </div>
        </div>
        <div className="business-grid">
          <article className="hero-card business-card reveal" style={{ '--delay': '140ms' }}>
            <div className="hero-card-top">
              <span>Project management</span>
              <span className="status">Lean Factor</span>
            </div>
            <div className="business-brand">
              <img
                className="business-logo leanfactor-logo"
                src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
                alt="Lean Factor logo"
              />
              <h2 className="app-title leanfactor-title">Lean Factor</h2>
            </div>
            <p>
              Lean Factor helps teams structure delivery, align stakeholders, and keep complex
              initiatives moving with clarity and discipline.
            </p>
            <ul className="business-list">
              <li>Project coordination and planning</li>
              <li>Stakeholder alignment and follow-up</li>
              <li>Execution support from kickoff to delivery</li>
            </ul>
            <div className="hero-card-actions">
              <a className="btn ghost" href="#/contact">
                Discuss a project
              </a>
            </div>
          </article>

          <article className="hero-card business-card reveal" style={{ '--delay': '260ms' }}>
            <div className="hero-card-top">
              <span>App development</span>
              <span className="status">JellyBeanStudios</span>
            </div>
            <div className="business-brand">
              <a
                className="business-logo-link"
                href="#/"
                aria-label="JellyBeanStudios home"
              >
                <img
                  className="business-logo"
                  src={`${process.env.PUBLIC_URL}/JellyBeanStudiosLogo.png`}
                  alt="JellyBeanStudios logo"
                />
              </a>
              <h2 className="app-title">JellyBeanStudios</h2>
            </div>
            <p>
              JellyBeanStudios designs and ships focused digital products, with simple user
              experiences and clear value from day one.
            </p>
            <ul className="business-list">
              <li>Product design and mobile app development</li>
              <li>Brand-led consumer app experiences</li>
              <li>Current releases: {apps[0].name} &amp; {apps[1].name}</li>
            </ul>
            <div className="hero-card-actions">
              <a className="btn primary" href={`#/app/${apps[0].slug}`}>
                View {apps[0].name}
              </a>
              <a className="btn primary" href={`#/app/${apps[1].slug}`}>
                View {apps[1].name}
              </a>
              <a className="btn ghost" href="#/apps">
                Browse all apps
              </a>
            </div>
          </article>
        </div>
      </section>

      <section className="section">
      </section>
    </>
  );
}

export default HomePage;
